import {useCallback, useEffect, useState} from 'react';

export function usePersistedState(key, defaultValue) {
  const [state, setState] = useState(
    () => JSON.parse(localStorage.getItem(key)) || defaultValue
  );

  const deleteState = useCallback(() => {
    localStorage.removeItem(key);
  }, [key]);

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(state));
  }, [key, state]);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === key) {
        if (!e.newValue) {
          setState(defaultValue);
          return;
        }

        setState(JSON.parse(e.newValue));
      }
    };

    window.addEventListener('storage', onStorage);

    return () => {
      window.removeEventListener('storage', onStorage);
    };
  }, [defaultValue, key]);

  return [state, setState, deleteState];
}
